
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sborka",
      function () {
        return require("private-next-pages/sborka.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sborka"])
      });
    }
  